import { Injectable } from '@angular/core';
import { FeathersAppService, FeathersServiceClass } from '@fire/feathers';
import { fireLogger } from '../../core/utils/fire-logger';
import { FeathersConnectionNames } from '../../core/config/feathers-connection-names';


export enum MasechtaTypes {
  Gemara = 1,
  Mishna = 2,
}

export interface MasechtaInterface {
  value:string,
  name:string,
}



@Injectable()
export class MasechtaService extends FeathersServiceClass {


  gemaraMasechtas:MasechtaInterface[] = null;
  mishnaMasechtas:MasechtaInterface[] = null;



  constructor(
    feathersAppService:FeathersAppService,
  ) {
    super(feathersAppService);
    fireLogger.log('initializing masechta service --- CONSTRUCTOR');

    this.init(FeathersConnectionNames.Main, {
      serviceName: 'masechtas',
      timeout: 5 * 60000,
    });
  }




  getGemaraMasechtas() {
    if (this.gemaraMasechtas) return Promise.resolve(this.gemaraMasechtas);

    return this.find({
      query: {
        type: MasechtaTypes.Gemara,
        $sort: {
          dafYomiOrder: 1,
        },
      },
    })
      .then(result => {
        this.gemaraMasechtas = result.data.map(masechta => ({
          value: masechta._id,
          name: masechta.hebrewName,
        }));
        return this.gemaraMasechtas;
      });
  }


  getMishnaMasechtas() {
    if (this.mishnaMasechtas) return Promise.resolve(this.mishnaMasechtas);

    return this.find({
      query: {
        $sort: {
          dafYomiOrder: 1,
          hebrewName: 1,
        },
      },
    })
      .then(result => {
        this.mishnaMasechtas = result.data.map(masechta => ({
          value: masechta._id,
          name: masechta.hebrewName,
        }));
        return this.mishnaMasechtas;
      });
  }








}


// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/services/masechta.service.ts